import { useCallback } from "react";

import { useAuthData } from "./context";

type ApiError = {
  // response: { message: string; error: string; statusCode: number };
  statusCode: number;
  message: string;
};

export const useAuthFetch = () => {
  const { token } = useAuthData();

  return useCallback(
    async (url: string, init?: RequestInit): ReturnType<typeof fetch> => {
      const response = await fetch(url, {
        ...init,
        headers: {
          ...init?.headers,
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        const data: ApiError = await response.json();
        throw new Error(data.message);
      }

      return response;
    },
    [token]
  );
};
